import { AnswerData, MessageData } from '@store'

import harlanAvatar from '/assets/temp/Harlan.png'
import authorAvatar from '/assets/temp/author.jpg'

type DialogItem = {
  id: string
  prevAnswer: string | null
  messages: MessageData[]
  answers: AnswerData[]
}

export const getDialogById = async (id: string) => {
  const data = dialog.filter((item) => item.id === id)
  const res = data.length ? data[0] : null

  return Promise.resolve(res)
}

export const dialog: DialogItem[] = [
  {
    id: '1',
    prevAnswer: null,
    messages: [
      {
        messageType: 'base',
        data: {
          id: '1-1',
          author: 'Echo',
          avatar: '',
          isPlayer: false,
          text: 'echo-1-1',
          audio: '/sounds/dialogs/Prologue_Echo_Full_good_D1_01.mp3',
        },
      },
    ],
    answers: [
      {
        text: 'echoAnswer-1-1_1',
        nextId: '2',
        id: '1-1-1',
      },
      { text: 'echoAnswer-1-1_2', nextId: '3', id: '1-1-2' },
      { text: 'echoAnswer-1-1_3', nextId: '4', id: '1-1-3' },
    ],
  },
  {
    id: '2',
    prevAnswer: '1-1-1',
    messages: [
      {
        messageType: 'base',
        data: {
          id: '2-1',
          author: 'Echo',
          avatar: '',
          isPlayer: false,
          text: 'echo-1-2',
          audio: '/sounds/dialogs/Prologue_Echo_Full_good_D1_011.mp3',
        },
      },
    ],
    answers: [
      {
        text: 'echoAnswer-1-2_1',
        nextId: '5',
        id: '2-1-1',
      },
    ],
  },
  {
    id: '3',
    prevAnswer: '1-1-2',
    messages: [
      {
        messageType: 'base',
        data: {
          id: '3-1',
          author: 'Echo',
          avatar: '',
          isPlayer: false,
          text: 'echo-1-3',
          audio: '/sounds/dialogs/Prologue_Echo_Full_good_D1_012.mp3',
        },
      },
    ],
    answers: [
      {
        text: 'echoAnswer-1-3_1',
        nextId: '5',
        id: '3-1-1',
      },
    ],
  },
  {
    id: '4',
    prevAnswer: '1-1-3',
    messages: [
      {
        messageType: 'base',
        data: {
          id: '4-1',
          author: 'Echo',
          avatar: '',
          isPlayer: false,
          text: 'echo-1-4',
          audio: '/sounds/dialogs/Prologue_Echo_Full_good_D1_013.mp3',
        },
      },
    ],
    answers: [
      {
        text: 'echoAnswer-1-4_1',
        nextId: '5',
        id: '4-1-1',
      },
    ],
  },
  {
    id: '5',
    prevAnswer: null,
    messages: [
      {
        messageType: 'base',
        data: {
          id: '5-1',
          author: 'Echo',
          avatar: '',
          isPlayer: false,
          text: 'echo-1-5',
          audio: '/sounds/dialogs/Prologue_Echo_Full_good_D1_02.mp3',
        },
      },
    ],
    answers: [
      {
        text: 'leave',
        nextId: 'end',
        id: 'end',
      },
    ],
  },
  {
    id: '6',
    prevAnswer: null,
    messages: [
      {
        messageType: 'base',
        data: {
          id: '6-1',
          author: 'Echo',
          avatar: '',
          isPlayer: false,
          text: 'echo-6-1', // Ты пришёл в место, которое не узнаёт себя без твоего взгляда...
          audio: '/sounds/dialogs/Prologue_Echo_Full_good_D2_01.mp3',
        },
      },
    ],
    answers: [
      {
        text: 'echoAnswer-6-1-1', // Что это за место?
        nextId: '7',
        id: '6-1-1',
      },
    ],
  },
  {
    id: '7',
    prevAnswer: '6-1-1',
    messages: [
      {
        messageType: 'base',
        data: {
          id: '7-1',
          author: 'Echo',
          avatar: '',
          isPlayer: false,
          text: 'echo-7-1', // Здесь пока ничего нет...
          audio: '/sounds/dialogs/Prologue_Echo_Full_good_D2_011.mp3',
        },
      },
    ],
    answers: [
      {
        text: 'echoAnswer-7-1-1', // Почему я ничего не помню?
        nextId: '8',
        id: '7-1-1',
      },
    ],
  },
  {
    id: '8',
    prevAnswer: '7-1-1',
    messages: [
      {
        messageType: 'base',
        data: {
          id: '8-1',
          author: 'Echo',
          avatar: '',
          isPlayer: false,
          text: 'echo-8-1', // Ты ищешь то, чего и не было...
          audio: '/sounds/dialogs/Prologue_Echo_Full_good_D2_012.mp3',
        },
      },
    ],
    answers: [
      {
        text: 'echoAnswer-8-1-1', // Здесь есть кто-то, кроме тебя?
        nextId: '9',
        id: '8-1-1',
      },
    ],
  },
  {
    id: '9',
    prevAnswer: '8-1-1',
    messages: [
      {
        messageType: 'base',
        data: {
          id: '9-1',
          author: 'Echo',
          avatar: '',
          isPlayer: false,
          text: 'echo-9-1', // Ты идёшь не один...
          audio: '/sounds/dialogs/Prologue_Echo_Full_good_D2_013.mp3',
        },
      },
    ],
    answers: [
      {
        text: 'echoAnswer-9-1-1', // А что мне теперь делать?
        nextId: '10',
        id: '9-1-1',
      },
    ],
  },
  {
    id: '10',
    prevAnswer: '9-1-1',
    messages: [
      {
        messageType: 'base',
        data: {
          id: '10-1',
          author: 'Echo',
          avatar: '',
          isPlayer: false,
          text: 'echo-10-1', // Ты ищешь цель. Или смысл?...
          audio: '/sounds/dialogs/Prologue_Echo_Full_good_D2_02.mp3',
        },
      },
    ],
    answers: [
      {
        text: 'echoAnswer-10-1-1', // Я хочу понять, что здесь происходит.
        nextId: '11',
        id: '10-1-1',
      },
      {
        text: 'echoAnswer-10-1-2', // Я хочу почувствовать, что мне делать.
        nextId: '12',
        id: '10-1-2',
      },
      {
        text: 'echoAnswer-10-1-3', // Я пока не знаю. Но я слушаю.
        nextId: '13',
        id: '10-1-3',
      },
    ],
  },
  {
    id: '11',
    prevAnswer: '10-1-1',
    messages: [
      {
        messageType: 'base',
        data: {
          id: '11-1',
          author: 'Echo',
          avatar: '',
          isPlayer: false,
          text: 'echo-11-1', // Понимание требует формы...
          audio: '/sounds/dialogs/Prologue_Echo_Full_good_D2_021.mp3',
        },
      },
    ],
    answers: [
      {
        text: 'leave',
        nextId: 'end',
        id: 'end',
      },
    ],
  },
  {
    id: '12',
    prevAnswer: '10-1-2',
    messages: [
      {
        messageType: 'base',
        data: {
          id: '12-1',
          author: 'Echo',
          avatar: '',
          isPlayer: false,
          text: 'echo-12-1', // Если ты готов чувствовать...
          audio: '/sounds/dialogs/Prologue_Echo_Full_good_D2_022.mp3',
        },
      },
    ],
    answers: [
      {
        text: 'leave',
        nextId: 'end',
        id: 'end',
      },
    ],
  },
  {
    id: '13',
    prevAnswer: '10-1-3',
    messages: [
      {
        messageType: 'base',
        data: {
          id: '13-1',
          author: 'Echo',
          avatar: '',
          isPlayer: false,
          text: 'echo-13-1', // Ты не выбираешь — и потому не ограничиваешь...
          audio: '/sounds/dialogs/Prologue_Echo_Full_good_D2_023.mp3',
        },
      },
    ],
    answers: [
      {
        text: 'leave',
        nextId: 'end',
        id: 'end',
      },
    ],
  },
  {
  id: '14',
  prevAnswer: null,
  messages: [
    {
      messageType: 'base',
      data: {
        id: '14-1',
        author: 'Author',
        avatar: authorAvatar,
        isPlayer: false,
        text: 'harlan-14-1', 
      },
    },
  ],
  answers: [
    {
      text: 'harlanAnswer-14-1-1', 
      nextId: '15',
      id: '14-1-1',
    },
  ],
},
{
  id: '15',
  prevAnswer: '14-1-1',
  messages: [
    {
      messageType: 'base',
      data: {
        id: '15-1',
        author: 'Harlan',
        avatar: harlanAvatar,
        isPlayer: false,
        text: 'harlan-15-1',
      },
    },
  ],
  answers: [
    {
      text: 'harlanAnswer-15-1-1', 
      nextId: '16',
      id: '15-1-1',
    },
    {
      text: 'harlanAnswer-15-1-2',
      nextId: '17',
      id: '15-1-2',
    },
    {
      text: 'harlanAnswer-15-1-3',
      nextId: '18',
      id: '15-1-3',
    },
  ],
},
{
  id: '16',
  prevAnswer: '15-1-1',
  messages: [
    {
      messageType: 'base',
      data: {
        id: '16-1',
        author: 'Harlan',
        avatar: harlanAvatar,
        isPlayer: false,
        text: 'harlan-16-1',
      },
    },
  ],
  answers: [
    {
      text: 'harlanAnswer-16-1-1', 
      nextId: '19',
      id: '16-1-1',
    },
  ],
},
{
  id: '17',
  prevAnswer: '15-1-2',
  messages: [
    {
      messageType: 'base',
      data: {
        id: '17-1',
        author: 'Harlan',
        avatar: harlanAvatar,
        isPlayer: false,
        text: 'harlan-17-1',
      },
    },
  ],
  answers: [
    {
      text: 'harlanAnswer-17-1-1', 
      nextId: '19',
      id: '17-1-1',
    },
  ],
},
{
  id: '18',
  prevAnswer: '15-1-3',
  messages: [
    {
      messageType: 'base',
      data: {
        id: '18-1',
        author: 'Harlan',
        avatar: harlanAvatar,
        isPlayer: false,
        text: 'harlan-18-1',
      },
    },
  ],
  answers: [
    {
      text: 'harlanAnswer-18-1-1', 
      nextId: '19',
      id: '18-1-1',
    },
  ],
},
{
  id: '19',
  prevAnswer: null,
  messages: [
    {
      messageType: 'base',
      data: {
        id: '19-1',
        author: 'Harlan',
        avatar: harlanAvatar,
        isPlayer: false,
        text: 'harlan-19-1',
      },
    },
  ],
  answers: [
    {
      text: 'harlanAnswer-19-1-1', 
      nextId: '20',
      id: '19-1-1',
    },
  ],
},
{
  id: '20',
  prevAnswer: '19-1-1',
  messages: [
    {
      messageType: 'base',
      data: {
        id: '20-1',
        author: 'Harlan',
        avatar: harlanAvatar,
        isPlayer: false,
        text: 'harlan-20-1',
      },
    },
  ],
  answers: [
    {
      text: 'harlanAnswer-20-1-1', 
      nextId: '21',
      id: '20-1-1',
    },
  ],
},
{
  id: '21',
  prevAnswer: '20-1-1',
  messages: [
    {
      messageType: 'base',
      data: {
        id: '21-1',
        author: 'Harlan',
        avatar: harlanAvatar,
        isPlayer: false,
        text: 'harlan-21-1',
      },
    },
  ],
  answers: [
    {
      text: 'harlanAnswer-21-1-1', 
      nextId: '22',
      id: '21-1-1',
    },
  ],
},
{
  id: '22',
  prevAnswer: '21-1-1',
  messages: [
    {
      messageType: 'base',
      data: {
        id: '22-1',
        author: 'Harlan',
        avatar: harlanAvatar,
        isPlayer: false,
        text: 'harlan-22-1',
      },
    },
  ],
  answers: [
    {
      text: 'harlanAnswer-22-1-1', 
      nextId: '23',
      id: '22-1-1',
    },
    {
      text: 'harlanAnswer-22-1-2', 
      nextId: '24',
      id: '22-1-2',
    },
    {
      text: 'harlanAnswer-22-1-3', 
      nextId: '25',
      id: '22-1-3',
    },
  ],
},
{
  id: '23',
  prevAnswer: '22-1-1',
  messages: [
    {
      messageType: 'base',
      data: {
        id: '23-1',
        author: 'Harlan',
        avatar: harlanAvatar,
        isPlayer: false,
        text: 'harlan-23-1',
      },
    },
  ],
  answers: [
    {
      text: 'harlanAnswer-23-1-1', 
      nextId: '26',
      id: '23-1-1',
    },
  ],
},
{
  id: '24',
  prevAnswer: '22-1-2',
  messages: [
    {
      messageType: 'base',
      data: {
        id: '24-1',
        author: 'Harlan',
        avatar: harlanAvatar,
        isPlayer: false,
        text: 'harlan-24-1',
      },
    },
  ],
  answers: [
    {
      text: 'harlanAnswer-24-1-1', 
      nextId: '26',
      id: '24-1-1',
    },
  ],
},
{
  id: '25',
  prevAnswer: '22-1-3',
  messages: [
    {
      messageType: 'base',
      data: {
        id: '25-1',
        author: 'Harlan',
        avatar: harlanAvatar,
        isPlayer: false,
        text: 'harlan-25-1',
      },
    },
  ],
  answers: [
    {
      text: 'harlanAnswer-25-1-1', 
      nextId: '26',
      id: '25-1-1',
    },
  ],
},
{
  id: '26',
  prevAnswer: null,
  messages: [
    {
      messageType: 'base',
      data: {
        id: '26-1',
        author: 'Harlan',
        avatar: harlanAvatar,
        isPlayer: false,
        text: 'harlan-26-1',
      },
    },
  ],
  answers: [
    {
      text: 'leave',
      nextId: 'end',
      id: 'end',
    },
  ],
},

]
